'use strict';

const Guide = function (resource) {
  return resource({
    url: function () {
      return '/guides';
    }
  });
};

Guide.$inject = [
  'resource'
];

export default Guide;



// WEBPACK FOOTER //
// ./app/src/resources/guide.js